/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Refund_Mode_FullInputs */

const vi_refund_mode_full = /** @type {(inputs: Refund_Mode_FullInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hoàn toàn bộ (${i?.amount})`)
};

/**

* @param {Refund_Mode_FullInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const refund_mode_full = /** @type {((inputs: Refund_Mode_FullInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refund_Mode_FullInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_refund_mode_full(inputs)
});